<template>
  <section class="noResults"
    data-name="no-results-found">
    <template v-if="customError">
      <h3>{{ customError.title }}</h3>
      <p v-html="customError.message" /> <!-- eslint-disable-line vue/no-v-html -->
    </template>
    <template v-else>
      <h3>Error {{ requestError.status }}</h3>
      <p>{{ requestError.statusText }}</p>
    </template>
    <p>
      Please create a ticket if you believe this is a issue <br>
      <a :href="jiraTicketURL"
        target="_blank">Create Jira ticket</a>
    </p>
  </section>
</template>

<script>
export default {
  name: 'MegaError',

  props: {
    requestError: {
      type: Object,
      default: null,
    },
    customError: {
      type: Object,
      default: null,
    },
  },

  computed: {
    user() {
      return this.$store.state.user
    },
    fullPath() {
      return window.location.href
    },
    jiraTicketURL() {
      const project = '10200'
      const summary = this.requestError
        ? `${this.requestError.status} ${this.requestError.statusText}`
        : `${this.customError.title} ${this.customError.message}`
      const app = '10010'
      const description = `Via ${this.fullPath}`
      return `https://jira.megaport.com/secure/CreateIssueDetails!init.jspa?pid=${project}&issuetype=10303&priority=3&summary=${summary}&customfield_10000=${app}&description=${description}&reporter=${this.user}`
    },
  },
}
</script>

<style lang="scss" scoped>
.noResults {
  background-color: #ededed;
  border-radius: 6px;
  text-align: center;
  padding: 6rem 0;
  p {
    margin-bottom: 1rem;
  }
}
</style>
